import { WHITE } from 'constants/colors'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const StyledLogo = styled(Link)`
  padding: 21px 20px;
  margin-bottom: 60px;

  svg path {
    fill: ${WHITE};
  }
`
